import { render } from "./onboarding-identity.vue?vue&type=template&id=8b3ebd8c"
import script from "./onboarding-identity.vue?vue&type=script&lang=js"
export * from "./onboarding-identity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__